import { Row } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  NavLink,
  LogoContainer,
  FooterContainer,
  LinksContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <FooterSection>
      <Container>
        <Row justify="space-between" align="middle">
          <NavLink to="/">
            <LogoContainer>
              <SvgIcon
                src="logo.svg"
                aria-label="homepage"
                width="160px"
                height="89px"
              />
            </LogoContainer>
          </NavLink>
          <FooterContainer>
            <LinksContainer>
              <NavLink to="/terms">Terms</NavLink>
              <NavLink to="/privacy">Privacy</NavLink>
            </LinksContainer>
            <SocialLink
              href="https://twitter.com/Chess_Zenith"
              src="twitter.svg"
            />
          </FooterContainer>
        </Row>
      </Container>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
